import { BrowserHttpClient } from '../adapter/browser/BrowserHttpClient.js';
import { BrowserNetApi } from '../adapter/browser/BrowserNetApi.js';
import { BrowserWebSocket } from '../adapter/browser/BrowserWebSocket.js';
import { AdapterManager } from '../adapter/manager/AdapterManager.js';
export { AdapterManager } from '../adapter/manager/AdapterManager.js';
import { AdapterType } from '../adapter/manager/types.js';
export { AdapterType } from '../adapter/manager/types.js';
import { BytedIMCore } from './BytedIM.js';
export { BytedIMCore } from './BytedIM.js';
export { ConversationStatus, ConversationType, CreateConvertsationStatusCode, ErrorType, FavoriteState, FlightStatus, IMEvent, InfoKeys, InitApiMode, InitResult, MessageSource, MuteState, PushPartDisableConfigWhiteListKey, PushStatus, SdkConsts, SendMessageStatusCode, ServerMessageStatus, StickTopState, TriggerType, WebSocketLevel } from './consts.js';
export { ContextClassBase, RuntimeContext, ServiceIdentity } from './service/RuntimeContext.js';
import 'long';
export { im_proto } from '../proto/index.js';
export { Logger, LoggerLevel } from './metrics/logger.js';
import 'json-long';
import 'moize';
export { Message, PropertyStatus } from './model/Message.js';
export { Monitor, MonitorItem } from './metrics/monitor.js';
export { TrackerItem } from './metrics/trackerTypes.js';
import 'tslib';
import './network/NetworkItem.js';
export { ConfigKeys, DbProxy } from './plugin/DbProxy.js';
export { Ticker } from './utils/ticker.js';
export { uuidv4 } from './utils/uuid.js';
export { CommandMessage, CommandType } from './model/CommandMessage.js';
export { deserialize, deserializeFrame, serialize, serializeFrame } from './utils/serializer.js';

class BytedIM extends BytedIMCore {
    initAdapter() {
        AdapterManager.setAdapter(AdapterType.HttpClient, BrowserHttpClient);
        AdapterManager.setAdapter(AdapterType.WebSocketClient, BrowserWebSocket);
        AdapterManager.setAdapter(AdapterType.NetApi, BrowserNetApi);
    }
}

export { BytedIM };
//# sourceMappingURL=index-browser.js.map
